import { render, staticRenderFns } from "./ZoneAlarmList.vue?vue&type=template&id=00036f9e&scoped=true&"
import script from "./ZoneAlarmList.vue?vue&type=script&lang=js&"
export * from "./ZoneAlarmList.vue?vue&type=script&lang=js&"
import style0 from "./ZoneAlarmList.vue?vue&type=style&index=0&id=00036f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00036f9e",
  null
  
)

export default component.exports